import React, {useEffect, useState} from "react";
import {useSelector, useRouterActions} from "../../../shared-services/redux-tiny";
import useWindowTools from "../../../react-hooks/useWindowTools";
import ProductPageDesktop from "./ProductPage.desktop";
import ProductPageMobile from "./ProductPage.mobile";
import useProductsFetcher from "../useProductsFetcher";
import productParser from "../productParser";
import {trackPageView} from "../../../services/tracking-helper";

const {ahoy} = window;

const ProductPage = (props) => {
  const {currentUser, currentLocale} = useSelector(state => state.session);
  const {setPageCode} = useRouterActions();

  const {widthOverStep, widthUnderStep} = useWindowTools();
  const {loadProduct} = useProductsFetcher();
  const parseProduct = productParser("productPage");

  const [product, setProduct] = useState({});
  const [pageTracked, setPageTracked] = useState(false);

  const fetchProduct = () => {
    const {productId} = props;
    loadProduct({productId}).then(response => {
      setProduct(parseProduct(response?.data, currentUser));
    });
  };

  useEffect(() => {
    fetchProduct();
  }, [currentLocale]);

  useEffect(() => {
    if (currentUser?.favorites && !product?.parsed) setProduct(parseProduct(product, currentUser));
  }, [currentUser, product]);

  useEffect(() => {
    if (!product?.id || pageTracked) return;

    ahoy.track("viewed-product", {
      product_id: product.id,
      id: product.id,
      permalink: product.permalink,
      channel: window.xSessionChannel
    });

    trackPageView("product", {products: product, trackingListName: "pdp"});

    setPageTracked(true);
  }, [product]);

  useEffect(() => {
    setPageCode("pdp");
  }, []);

  return <>
    {widthOverStep("sm") &&
      <ProductPageDesktop product={product} setProduct={setProduct} {...props}/>
    }

    {widthUnderStep("sm", true) &&
      <ProductPageMobile product={product} setProduct={setProduct} {...props}/>
    }
  </>;
};

export default ProductPage;
